import QRCode from 'qrcodejs2';
export default {
  meta: {
    title: '获取二维码'
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 128
    },
    height: {
      type: Number,
      default: 128
    }
  },
  data() {
    return {
      Qrcimg: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.crateQrcode();
    });
  },
  watch: {},
  methods: {
    crateQrcode() {
      this.innerVisible = true;
      let qrcodeUrl = this.url;
      console.log(qrcodeUrl);
      this.qr = new QRCode(this.$refs.qrcode, {
        width: this.width,
        height: this.height,
        text: qrcodeUrl,
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        background: '#f0f',
        foreground: '#ff0'
      });
      const myCanvas = document.getElementsByTagName('canvas')[0];
      const imgurl = myCanvas.toDataURL('image/png');
      this.Qrcimg = imgurl;
    }
  }
};